/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Access_DeniedInputs */

const fr_auth_access_denied = /** @type {(inputs: Auth_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte n’a pas accès à BusinessFlow. Utilisez le compte invité ou contactez un administrateur.`)
};

const en_auth_access_denied = /** @type {(inputs: Auth_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account cannot access BusinessFlow. Use your invited account or contact an administrator.`)
};

/**
* | output |
* | --- |
* | "This account cannot access BusinessFlow. Use your invited account or contact an administrator." |
*
* @param {Auth_Access_DeniedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_access_denied = /** @type {((inputs?: Auth_Access_DeniedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Access_DeniedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_access_denied(inputs)
	return fr_auth_access_denied(inputs)
});